<div class="container-fluid">
  <div class="row" style="padding-top: 15px">
    <div class="col-md-12 mt-2 flex-align-items">
      <h4 class="mb-0">
        {{ 'LogExport' | translate }}
        <app-help hrefKey="ExternalHelp.log-export" />
      </h4>
    </div>
  </div>
  <hr />

  @if (currentConfig) {
    <h5 class="flex-align-items">
      {{ 'Status' | translate }}
      <button
        (click)="getStats()"
        class="btn btn-primary btn-sm btn-reload ml-2"
        title="{{ 'Refresh' | translate }}"
      >
        <i class="icon-reload"></i>
      </button>
    </h5>
    <div class="mt-3">
      <div *ngIf="!stats && !isLoading && !statsError">{{ 'StatsWillAppearHere' | translate }}</div>
      <div *ngIf="statsError">{{ 'StatsNotReady' | translate }}</div>
      <span *ngIf="isLoading" class="text-placeholder cards"><span class="activity"></span></span>
      <div *ngIf="stats" class="stats flex-align-items">
        <div>
          {{ 'EventsSentCurrent' | translate }} : <span>{{ stats?.output_throughput?.current || '-' }}</span>
        </div>
        <div>
          {{ 'EventsSentInLastMinute' | translate }} :
          <span>{{ stats?.output_throughput?.last_1_minute || '-' }}</span>
        </div>
        <div>
          {{ 'EventsSentInLast15Minutes' | translate }} :
          <span>{{ stats?.output_throughput?.last_15_minutes || '-' }}</span>
        </div>
        <div>
          {{ 'EventsSentInLast1Hour' | translate }} : <span>{{ stats?.output_throughput?.last_1_hour || '-' }}</span>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <h5>{{ 'YourCurrentSetup' | translate }}</h5>
      <div class="log-export-type static">
        <div class="flex-align-items">
          <div class="flex-align-items">
            <img [src]="'assets/images/' + currentConfig.type + '.png'" style="width: 25px" />
            <div>
              <div>{{ 'PushLog.label.' + currentConfig.type | translate }}</div>
              @if (compats[currentConfig.type]) {
                <div class="compat">{{ 'PushLog.compat' | translate: { compatList: compats[currentConfig.type] } }}</div>
              }
            </div>
          </div>
        </div>
        <json-viewer [json]="pushLogConf[currentConfig.type]" [expanded]="true"/>
      </div>
    </div>
    <p [innerHTML]="'EnableExportSiteYouOwn' | translate"></p>
    <div *ngIf="exportType != 'sekoia'" class="form-group bg-light p-2">
      {{ 'LogsOutgoingIps' | translate }} {{ logsOutgoingIps }}
    </div>
    <div
      *ngIf="
        exportType == 'syslog' ||
        (exportType == 'tcp' && pushLogConf[exportType].sslEnabled)
      "
      class="form-group bg-light p-2"
    >
      {{ 'TrustOgoCA' | translate }}.<br /><br />
      <a
        *ngIf="exportType == 'tcp' || exportType == 'syslog'"
        [href]="STATIC_LINK_OGO_CA_CERT"
        download
      >
        <button class="btn btn-primary" title="{{ 'Download' | translate }}">
          {{ 'Telecharger' | translate }} OGO CA Cert&nbsp;&nbsp;<i class="icofont icofont-download-alt"></i>
        </button>
      </a>
      <br /><br />
      <a
        class="ogo-link"
        target="_blank"
        [href]="'ExternalHelp.log-export-' + exportType | translate"
      >{{ 'ExportGuide' | translate }} {{ exportType | uppercase }}
        <i class="icofont icofont-external-link ml-1"></i>
      </a>
    </div>
    <hr />
    @if (step == 'CONFIGURED') {
      <div class="btn-container">
        <button (click)="triggerDeletePushLogConf()" class="btn btn-sm btn-danger">
          {{ 'supprimer' | translate }}
        </button>
        <button (click)="step = 'NOT_CONFIGURED'" class="btn btn-sm btn-primary">
          {{ 'Modifier' | translate }}
        </button>
      </div>
    }
  }
  @switch (step) {
    @case ('NOT_CONFIGURED') {
      <div class="form-group mb-0">
        <p>{{ 'ChooseAnExportType' | translate }}</p>
        <div class="row">
          @for (type of PushLogConfigTypes; track type) {
            <div class="col-xxl-4 col-md-6">
              <div class="log-export-type option pointer flex-align-items" (click)="selectLogExportType(type)">
                <div class="log-export-image-container">
                  <img [src]="'assets/images/' + type + '.png'"/>
                </div>
                <div>
                  <div>{{ 'PushLog.label.' + type | translate }}</div>
                  @if (compats[type]) {
                  <div class="compat">{{ 'PushLog.compat' | translate: { compatList: compats[type] } }}</div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (currentConfig) {
          <hr />
          <div class="btn-container">
            <button (click)="step = 'CONFIGURED'" class="btn btn-sm btn-danger">
              {{ 'Annuler' | translate }}
            </button>
          </div>
        }
      </div>
    }
    @case ('EDITING') {
      <p>{{ 'PleaseFillFollowingInformations' | translate }}</p>
      <div class="row">
        <div class="col-xxl-4 col-xl-6">
          <div class="log-export-type static">
            <div class="flex-align-items">
                <img [src]="'assets/images/' + exportType + '.png'"/>
                <div>
                  <div>{{ 'PushLog.label.' + exportType | translate }}</div>
                  @if (compats[exportType]) {
                  <div class="compat">{{ 'PushLog.compat' | translate: { compatList: compats[exportType] } }}</div>
                  }
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xxl-4 col-xl-6">
          @switch (exportType) {
            @case ('tcp') {
              <div class="form-group">
                <label>TCP Host</label>
                <input [(ngModel)]="pushLogConf.tcp.host" class="form-control" type="text"
                       placeholder="logs.example.com" />
              </div>
              <div class="form-group">
                <label>TCP Port</label>
                <input [(ngModel)]="pushLogConf.tcp.port" class="form-control" type="text" placeholder="12345" />
              </div>
              <div class="form-group mt-4" style="margin-left: 3px">
                <input id="tcp-tls" type="checkbox" [(ngModel)]="pushLogConf.tcp.sslEnabled" />
                <label for="tcp-tls" class="ml-2">TLS</label>
              </div>
              <ng-container *ngTemplateOutlet="outgoingIps"></ng-container>
              <div class="form-group bg-light p-2" *ngIf="pushLogConf.tcp.sslEnabled">
                {{ 'TrustOgoCA' | translate }}. <br /><br />
                <a [href]="STATIC_LINK_OGO_CA_CERT" download>
                  <button class="btn btn-primary" title="{{ 'Download' | translate }}">
                    {{ 'Telecharger' | translate }} OGO CA Cert&nbsp;&nbsp;<i class="icofont icofont-download-alt"></i>
                  </button>
                </a>
                <br /><br />
                <a class="ogo-link" target="_blank" [href]="'ExternalHelp.log-export-' + exportType | translate"
                >{{ 'ExportGuide' | translate }} {{ exportType | uppercase }}
                  <i class="icofont icofont-external-link ml-1"></i>
                </a>
              </div>
            }
            @case ('splunk') {
              <div class="form-group">
                <label>Splunk URL</label>
                <input
                  class="form-control"
                  type="text"
                  [(ngModel)]="pushLogConf.splunk.url"
                  placeholder="<protocol>://<host>.splunkcloud.com:<port>/<endpoint>/raw"
                />
              </div>
              <div class="form-group">
                <label>Splunk HEC Token</label>
                <input
                  class="form-control"
                  type="text"
                  [(ngModel)]="pushLogConf.splunk.hecToken"
                  placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"
                />
              </div>
              <div class="form-group mt-4 ml-1">
                <input
                  type="checkbox"
                  [ngModel]="pushLogConf.splunk.sslVerificationMode == 'full' ? true : false"
                  (ngModelChange)="pushLogConf.splunk.sslVerificationMode = $event ? 'full' : 'none'"
                />
                <label class="ml-2"> &nbsp;{{ 'VerifyServerCertificate' | translate }} </label>
              </div>
              <ng-container *ngTemplateOutlet="outgoingIps"></ng-container>
            }
            @case ('sekoia') {
              <div class="form-group">
                <label>Sekoia INTAKE_KEY</label>
                <input [(ngModel)]="pushLogConf.sekoia.intakeKey" class="form-control" type="text" />
              </div>
            }
            @case ('microsoftSentinelv2') {
              <div class="form-group">
                <label>Client App ID</label>
                <input [(ngModel)]="pushLogConf.microsoftSentinelv2.clientAppId" class="form-control" type="text" />
              </div>
              <div class="form-group">
                <label>Client App Secret</label>
                <input [(ngModel)]="pushLogConf.microsoftSentinelv2.clientAppSecret" class="form-control" type="text" />
              </div>
              <div class="form-group">
                <label>Tenant ID</label>
                <input [(ngModel)]="pushLogConf.microsoftSentinelv2.tenantId" class="form-control" type="text" />
              </div>
              <div class="form-group">
                <label>Data Collection Endpoint</label>
                <input
                  [(ngModel)]="pushLogConf.microsoftSentinelv2.dataCollectionEndpoint"
                  class="form-control"
                  type="text"
                />
              </div>
              <div class="form-group">
                <label>DCR Immutable ID</label>
                <input [(ngModel)]="pushLogConf.microsoftSentinelv2.dcrImmutableId" class="form-control" type="text" />
              </div>
              <div class="form-group">
                <label>DCR Stream Name</label>
                <input [(ngModel)]="pushLogConf.microsoftSentinelv2.dcrStreamName" class="form-control" type="text" />
              </div>
              <ng-container *ngTemplateOutlet="outgoingIps"></ng-container>
              <div class="form-group bg-light p-2">
                {{ 'LogExampleDesc' | translate }}<br /><br />
                <a [href]="STATIC_LINK_OGO_LOG_EXAMPLE" download>
                  <button class="btn btn-primary" title="{{ 'Download' | translate }}">
                    {{ 'Telecharger' | translate }} {{ 'LogExample' | translate }} Microsoft Sentinel V2&nbsp;&nbsp;<i
                    class="icofont icofont-download-alt"
                  ></i>
                  </button>
                </a
                ><br /><br />
                <a class="ogo-link" target="_blank" [href]="'ExternalHelp.log-export-microsoftSentinelv2' | translate"
                >{{ 'ExportGuide' | translate }} Microsoft Sentinel V2
                  <i class="icofont icofont-external-link ml-1"></i>
                </a>
              </div>
            }
            @case ('syslog') {
              <div class="form-group">
                <app-label label="SYSLOG APP-NAME" [url]="EXTERNAL_RFC_5424_SYSLOG_LINK" />
                <input [(ngModel)]="pushLogConf.syslog.appName" class="form-control" type="text" placeholder="OGO-LOGS" />
              </div>
              <div class="form-group">
                <label>SYSLOG Host</label>
                <input
                  [(ngModel)]="pushLogConf.syslog.host"
                  class="form-control"
                  type="text"
                  placeholder="logs.example.com"
                />
              </div>
              <div class="form-group">
                <label>SYSLOG Port</label>
                <input [(ngModel)]="pushLogConf.syslog.port" class="form-control" type="text" placeholder="12345" />
              </div>
              <div class="form-group mt-4" style="margin-left: 3px">
                <input id="syslog-tls" type="checkbox" [(ngModel)]="pushLogConf.syslog.sslEnabled" />
                <label for="syslog-tls" class="ml-2">TLS</label>
              </div>
              <ng-container *ngTemplateOutlet="outgoingIps"></ng-container>
              <div class="form-group bg-light p-2" *ngIf="pushLogConf.syslog.sslEnabled">
                {{ 'TrustOgoCA' | translate }}.<br /><br />
                <a [href]="STATIC_LINK_OGO_CA_CERT" download>
                  <button class="btn btn-primary" title="{{ 'Download' | translate }}">
                    {{ 'Telecharger' | translate }} OGO CA Cert&nbsp;&nbsp;<i class="icofont icofont-download-alt"></i>
                  </button>
                </a
                ><br /><br />
                <a class="ogo-link" target="_blank" [href]="'ExternalHelp.log-export-' + exportType | translate"
                >{{ 'ExportGuide' | translate }} {{ exportType | uppercase }}
                  <i class="icofont icofont-external-link ml-1"></i>
                </a>
              </div>
            }
          }
        </div>
      </div>
      <hr />
      <div class="btn-container mb-3">
        <button (click)="step = 'NOT_CONFIGURED'; exportType = undefined" class="btn btn-sm btn-danger">
          {{ 'Annuler' | translate }}
        </button>
        <button
          *ngIf="step == 'EDITING'"
          (click)="currentConfig ? triggerModifyPushLogConf() : saveUpdatePushLogConf()"
          class="btn btn-sm btn-primary"
        >
          {{ 'Validate' | translate }}
        </button>
      </div>
    }
  }

</div>

<ng-template #outgoingIps>
  <div class="form-group bg-light p-2">{{ 'LogsOutgoingIps' | translate }} {{ logsOutgoingIps }}</div>
</ng-template>
